/* eslint-disable import/no-cycle */
// eslint-disable-next-line import/prefer-default-export
// eslint-disable-next-line import/no-cycle

import { formatInTimezone } from '@wk/timezone';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { detect } from 'detect-browser';
import Cookie from 'js-cookie';
import router from 'next/router';
import { parse } from 'qs';

import { goStudentCenterHome } from '@/components/ExperienceClassBooking/utils';
import { StudentInfo } from '@/request/interface/login';

import { getGS20DivertL } from './constants';
import { getJwtTokenInfo, setSameDomain } from './token';

dayjs.extend(timezone);
dayjs.extend(utc);

export const isProduction = () => process.env.NEXT_PUBLIC_STAGE === 'prod';
// eslint-disable-next-line import/no-cycle

// eslint-disable-next-line import/prefer-default-export
export const generateId = (): any => {
  const cookieId = localStorage.getItem('cookie_id');
  if (!cookieId) {
    const newCookieId = `cookie_id${new Date().getTime()}`;
    localStorage.setItem('cookie_id', newCookieId);
  }
  return cookieId;
};

export const getQueryString = (name: string): any => {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
  const r = window.location.search.substr(1).match(reg);
  if (r !== null) {
    return decodeURIComponent(r[2]);
  }
  return null;
};

/**
 * 判断是否是PC设备
 *
 */
export const isPC = (userAgent?: string) =>
  !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    userAgent || globalThis?.navigator?.userAgent || '',
  );

// 获取最大和最小的 随机整数
export const randomIntFromInterval = (min: number, max: number): number => {
  // min和max为范围的最小值和最大值
  return Math.floor(Math.random() * (max - min + 1) + min);
};

interface Env {
  prod: string;
  test: string;
  dev: string;
}

export const cdnDomain = 'https://cdnwukong.com';

export const DATE_FORMAT = 'YYYY-MM-DD';

// const envOrigin = {
//   prod: 'https://www.wukongsch.com',
//   test: 'https://wwww-test.wukongedu.net',
//   develop: 'https://wwww-dev.wukongedu.net',
// };

const stuEnvOrigin = {
  prod: 'https://student.wukongsch.com',
  prod_edu: 'https://student.wukongedu.net',
  test: 'https://student-test.wukongedu.net',
  dev: 'https://student-dev.wukongedu.net',
};

export const getStuCenterHost = (from?: string) => {
  const fromParam = from || 'newofficial_website';
  const lang = window.location.href.includes('/zh/') ? 'zh' : 'en';
  let origin =
    stuEnvOrigin[(process.env.NEXT_PUBLIC_STAGE as keyof Env) || 'develop'];
  if (
    process.env.NEXT_PUBLIC_STAGE === 'prod' &&
    window.location.hostname.includes('wukongedu.net')
  ) {
    origin = stuEnvOrigin.prod_edu;
  }
  return { origin, lang, fromParam };
};

export const getStuCenterUrl = (
  from?: string,
  router?: string,
  hasQuery?: boolean,
  notNeedFromParam?: boolean,
) => {
  setSameDomain();
  const { origin, lang, fromParam } = getStuCenterHost(from);
  const url = `${origin}/${lang}/${router || ''}`;
  if (notNeedFromParam) {
    return url;
  }
  return `${url}${hasQuery ? '&' : '?'}from=${fromParam}`;
};

export const isIOS = () => {
  const { userAgent } = navigator;
  return /iPhone|iPad|iPod/i.test(userAgent);
};

/**
 * 判断是否是进入学员中心首页
 * @param decodeUrl
 * @returns
 */
const isRedirectStuCenterHome = (decodeUrl: string) => {
  /* 如果是学员中心嵌入互动作业地址，直接跳学员中心首页 */
  if (decodeUrl.includes('/iexercise?')) {
    return true;
  }

  /* 如果免密登录的邮箱与用户输入的邮箱不是同一个，则跳转学员中心首页 */
  if (window.location.search.includes('login_code_page_email=')) {
    const { login_code_page_email: email } = parse(
      window.location.search.slice(1),
    );
    const userLoginEmail = localStorage.getItem('preEmail');
    return email && userLoginEmail && email !== userLoginEmail;
  }

  return false;
};

export const getLoginJumpUrl = (from?: string, notNeedFromParam?: boolean) => {
  const fromParam = from || 'newofficial_website';
  const { return_url: returnUrl } = parse(
    window?.location?.search?.slice(1) || '',
  );
  if (returnUrl) {
    setSameDomain();
    const decodeUrl = decodeURIComponent(returnUrl as string);

    /* 判断是否直接进入学员中心首页 */
    if (isRedirectStuCenterHome(decodeUrl)) {
      return getStuCenterUrl('', '', false, notNeedFromParam);
    }

    const lang = window.location.href.includes('/zh/') ? 'zh' : 'en';

    // 如果returnUrl上无语言信息，需要强当前语言信息加上
    // if (!decodeUrl.includes(`/en`) && !decodeUrl.includes(`/zh`)) {
    //   const origin =
    //     isProduction() && window.location.hostname.includes('wukongsch.com') ? 'wukongsch.com' : 'wukongedu.net';
    //   decodeUrl = decodeUrl.replace(`${origin}`, `${origin}/${lang}`);
    // }
    // 不管 returnUrl 上有语言信息，还是无语言信息，都需要加上当前语言信息
    const { origin, pathname, search } = new URL(decodeUrl);
    const path = pathname?.replace(/(\/zh)|(\/en)/, '');
    const newHref = `${origin}/${lang}${path}${search}`;
    if (notNeedFromParam) {
      return newHref;
    }
    if (newHref.includes('?')) {
      return newHref.includes('from=')
        ? newHref
        : `${newHref}&from=${fromParam}`;
    }
    return `${newHref}?from=${fromParam}`;
  }
  return getStuCenterUrl('', '', false, notNeedFromParam);
};

/**
 * 跳转到学员中心登录页面
 * 登录成功后会返回到 return_url 指定的页面
 *
 * @param returnUrl - 登录后返回的 URL，默认为当前页面 URL
 */
export const redirectToStuCenterLogin = (returnUrl?: string) => {
  const url = returnUrl || window.location.href;
  router.push(`/student-center-login?return_url=${encodeURIComponent(url)}`);
};

/**
 * 根据unix时间戳获取时区日期
 *
 * @param expireTime - 时间戳
 * @param timezone - 时区
 * @param format - 格式化
 * @param offset - 时间偏移量(天数)，负数表示往前推，正数表示往后推
 * @returns 时区日期
 */
export const getTimezoneDateFromUnix = (
  expireTime: number,
  timezone?: string,
  format: string = 'YYYY-MM-DD HH:mm:ss',
  offset: number = 0,
) => {
  // 将毫秒转换为秒
  const timestampInSeconds = Math.floor(expireTime / 1000);
  const targetTime = dayjs.unix(timestampInSeconds).add(offset, 'day').toDate();
  if (timezone) {
    return formatInTimezone(targetTime, timezone, format);
  }
  const localTime = dayjs(targetTime).tz(dayjs.tz.guess());
  return localTime.format(format);
};

/**
 * 等待 Intercom 初始化完成
 * @param timeout 超时时间（毫秒）
 * @returns Promise<void>
 */
export const waitForIntercom = (timeout = 10000): Promise<void> => {
  return new Promise((resolve, reject) => {
    const startTime = Date.now();

    const checkIntercom = () => {
      if (window?.Intercom) {
        resolve();
        return;
      }

      if (Date.now() - startTime > timeout) {
        reject(new Error('Intercom initialization timeout'));
        return;
      }

      setTimeout(checkIntercom, 100);
    };

    checkIntercom();
  });
};

export const hideIntercomUrls = [
  'terms',
  'policy',
  'independent-appointment',
  'agreement',
  // 'student-center-login',
  'app/download',
  'app/captcha',
  'booking-redirect',
  'experienceclassbooking',
  'trial-class/booking',
  'math/free-trial',
];

// 存储 Intercom 信息，以便在 Intercom 延迟加载时使用
declare global {
  interface Window {
    pendingIntercomInfo?: {
      isGuest: boolean;
      data?: any;
    };
  }
}

export const updateIntercomInfo = async (currentStudent?: StudentInfo) => {
  if (
    hideIntercomUrls.some(item =>
      window.location.pathname.toLowerCase().includes(item),
    )
  ) {
    return;
  }

  // 准备 Intercom 信息
  let intercomInfo: any;
  if (currentStudent?.uuid && currentStudent?.hmacSHA256AccountId) {
    const language = window.location.href.includes('/zh/') ? 'ZH' : 'EN';
    const {
      uuid,
      fullName,
      hmacSHA256AccountId,
      data,
      chinesePayStatus,
      englishPayStatus,
      mathPayStatus,
      country,
      code,
      payStatus,
      timezoneStd,
    } = currentStudent || {};
    // 为 intercom 客服系统设置登录态
    const subjects = [];
    if (chinesePayStatus === 'PAID') {
      subjects.push('Chinese');
    }
    if (englishPayStatus === 'PAID') {
      subjects.push('ELA');
    }
    if (mathPayStatus === 'PAID') {
      subjects.push('Math');
    }
    intercomInfo = {
      user_id: uuid,
      name: fullName,
      Country: country,
      City: data?.city,
      Subject: subjects.join(','),
      StudentCode: code,
      Language: language,
      PayStatus: payStatus,
      user_hash: hmacSHA256AccountId,
      Source: isPC() ? 'WEB' : 'WEB-MOBILE',
      HasRegister: '已注册',
      LastLoginTime: `${getTimezoneDateFromUnix(
        getJwtTokenInfo()?.exp || 0,
        timezoneStd,
        'YYYY-MM-DD HH:mm',
        -30,
      )} (${timezoneStd})`,
    };

    // 存储信息供延迟加载使用
    window.pendingIntercomInfo = {
      isGuest: false,
      data: intercomInfo,
    };
  } else {
    intercomInfo = {
      Source: isPC() ? 'WEB' : 'WEB-MOBILE',
      HasRegister: '未注册',
    };

    // 存储信息供延迟加载使用
    window.pendingIntercomInfo = {
      isGuest: true,
      data: intercomInfo,
    };
  }

  // 尝试立即更新 Intercom
  try {
    await waitForIntercom(500); // 等待很短的时间看 Intercom 是否已加载
    window?.Intercom?.('update', intercomInfo);
  } catch (error) {
    // Intercom 尚未加载，信息已存储在 window.pendingIntercomInfo 中
    // 延迟加载组件将在加载时使用这些信息
  }
};

const pathName: { [key: string]: string } = {
  '/': 'HomePage',
  '/why-wukong': 'How',
  '/chinese': 'ChineseCourse',
  '/math': 'MathCourse',
  '/english': 'EnglishCourse',
  '/download': 'APPDownload',
};

export const getGa4PageName = (path: string) => {
  const defaultPageName = 'NotFoundPage'; // 默认页面名称

  // 检查给定的路径是否在 pathName 对象中，并且对应的值不为 undefined
  if (pathName[path] !== undefined) {
    return pathName[path]; // 返回对应的页面名称
  }
  return defaultPageName; // 返回默认页面名称
};

export const isChrome = () =>
  /Chrome/.test(navigator.userAgent) && !/Edg/.test(navigator.userAgent);

/**
 *通过url获取文件名
 *
 * @param {string} url
 * @return {*}  {string}
 */
export const getFileNameFromUrl = (url: string): string => {
  const lastSlashIndex = url?.lastIndexOf?.('/');
  const fileName = url?.substring?.(lastSlashIndex + 1);
  return decodeURIComponent(fileName);
};

/**
 * PC端下载文件
 * @param {String} path - 下载地址/下载请求地址。
 * @param {String} fileName - 下载文件的名字（考虑到兼容性问题，最好加上后缀名）
 */
// export const downloadFileForPC = (url: string, fileName?: string) => {
//   fetch(url)
//     .then((response) => response.blob())
//     .then((blob) => {
//       const link = document.createElement('a');
//       link.href = URL.createObjectURL(blob);
//       link.download = fileName || getFileNameFromUrl(url);
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     });
// };

/**
 * 下载文件
 * @param {String} path - 下载地址/下载请求地址。
 */
export const downloadFile = (url: string) => {
  const link = document.createElement('a');
  link.href = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

/**
 * 将单词首字母变为大写
 *
 * @param {string} string
 * @return {*}
 */
export const capitalizeFirstLetter = (string: string) => {
  // 如果字符串为空，则返回空字符串
  if (!string) {
    return '';
  }

  // 将字符串的第一个字母转换为大写，并将其与字符串的其余部分连接起来
  return string[0].toUpperCase() + string.slice(1);
};

/**
 * 将秒数转换为时分秒格式
 *
 * @param {number} seconds
 * @return {*}
 */
export const formatSecondsToTime = (seconds: number) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(remainingSeconds).padStart(2, '0');

  if (formattedHours === '00') {
    return `${formattedMinutes}:${formattedSeconds}`;
  }

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

/**
 * 根据视频URL获取视频时长
 *
 * @param {string} fileUrl
 * @param {(time: string) => void} callback
 */
export const getVideoTime = (
  fileUrl: string,
  callback: (time: string) => void,
) => {
  const video = document.createElement('video');
  video.src = fileUrl as string;
  video.addEventListener('loadedmetadata', () => {
    if (!video?.duration) {
      return;
    }
    const time = formatSecondsToTime(video.duration);
    callback(time);
  });
};

/**
 * 根据音频URL获取音频时长
 *
 * @param {string} fileUrl
 * @param {(time: string) => void} callback
 */
export const getAudioTime = (
  fileUrl: string,
  callback: (time: string) => void,
) => {
  const audio = new Audio();
  audio.src = fileUrl;

  audio.addEventListener('loadedmetadata', () => {
    if (!audio?.duration) {
      return;
    }
    const time = formatSecondsToTime(audio.duration);
    callback(time);
  });
};

/**
 * 对象数组去重
 *
 * @param {any[]} array 需要去重的数组
 * @param {string} keyName 去重属性，当这个属性相等是默认是重复项
 * @return {*}
 */
export const deduplicateArray = (array: any[], keyName: string) => {
  const uniqueArray = array.filter((item, index) => {
    const foundIndex = array.findIndex((element, idx) => {
      return element[keyName] === item[keyName] && idx < index;
    });
    return foundIndex === -1;
  });
  return uniqueArray;
};

export const getIsAndroid = (): boolean => {
  const u = window?.navigator.userAgent;
  return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
};

export const checkBrowerType = () => {
  return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;
};

export const checkWeixin = () => {
  return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;
};

export const checkIsApple = () => {
  const resultDetect = detect();
  return /iOS|Mac OS/i.test(resultDetect?.os || '');
};

export const isMobile = () => {
  if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
    return true;
  }
  return false;
};

export const copyToClipboard = (str: string) => {
  return new Promise((resolve, reject) => {
    if (str === '') {
      reject(new Error('没有复制内容'));
    }
    const el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    resolve(true);
  });
};

/**
 * 是否为安卓平板（不含安卓手机）。
 *
 * 1. 标准 Android UA：含 Android 且不含 Mobile → 平板（Google 官方 UA 规范）
 * 2. 桌面模式 UA（如小米平板 MIUI 浏览器）：UA 为 "X11; Linux" 无 Android，
 *    但含厂商标识（XiaoMi/Huawei 等）且支持触屏 → 平板
 */
export const isAndroidTablet = (): boolean => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }
  const ua = navigator.userAgent;

  // 标准 Android UA：手机带 Mobile，平板不带
  if (/Android/i.test(ua)) {
    return !/Mobile/i.test(ua);
  }

  // 桌面模式：MIUI / Huawei 等平板浏览器会把 UA 伪装成 X11; Linux
  if (
    /X11;\s*Linux/i.test(ua) &&
    /XiaoMi|MiuiBrowser|HuaweiBrowser|HONOR|OPPO|vivo/i.test(ua) &&
    navigator.maxTouchPoints > 0
  ) {
    return true;
  }

  return false;
};

export const getAppPlatform = () => {
  const { userAgent } = navigator;
  const isAndroid = /Android/i.test(userAgent);
  const isTablet =
    /Android/i.test(userAgent) && /Mobile/i.test(userAgent) === false;
  const isIPhone = /iPhone/i.test(userAgent);
  const isIPad = /iPad/i.test(userAgent);
  if (isAndroid || isTablet) {
    return 'ANDROID';
  }
  if (isIPhone || isIPad) {
    return 'IOS';
  }
  return 'WEB';
};

export const formatAppEnv = (appEnv: string) => {
  const appEnvMap = {
    app_ios: 'IOS',
    app_android: 'ANDROID',
  };
  return appEnvMap?.[appEnv as 'app_ios' | 'app_android'] || 'WEB';
};

// 检索ga或fb渠道
// eslint-disable-next-line consistent-return
export const pixelChannel = (id: any) => {
  if (id === '79ad83aa-a0ab-45c7-addb-8d72f73f318f') {
    return 'GA';
  }
  if (id === '17cd3889-4876-43a8-b3c8-c0f8d08c655d') {
    return 'PIXEL';
  }
  // 喜马拉雅
  if (id === 'ad01e1a2-bd34-42f2-9df9-189d9d579f01') {
    return 'XMLY';
  }
  // pintrk
  if (id === '9289f76b-366d-4ef6-b00c-533125cfcd6c') {
    return 'PINTEREST';
  }
  // Bing
  if (id === '050c24b6-6534-42ba-a39d-7c445aed7a36') {
    return 'BING';
  }
  if (id === 'e631acc0-de40-4185-ae21-57986a2f6513') {
    return 'SHARE_A_SALE';
  }
  if (id === '2b96e9d0-6ecb-4634-8f05-3c33a84c7406') {
    return 'Taboola';
  }
  if (id === 'ea8db6c1-f9b1-4353-8339-c62282d70017') {
    return 'Twitter';
  }
  if (id === 'ce980e9d-6018-4a8e-b301-d764b820b5f3') {
    return 'TikTok';
  }
  return 'other';
};

// 判断各种类型是否为空
export const isEmpty = (value: any): boolean => {
  // null 或者 未定义，则为空
  if (value === null || value === undefined) {
    return true;
  }
  // 传入空字符串，则为空
  if (typeof value === 'string') {
    return value === '';
  }
  // 传入数组长度为0，则为空
  if (value instanceof Array) {
    return !value.length;
  }
  // 传入空对象，则为空
  if (value instanceof Object) {
    return !Object.keys(value).length;
  }
  return false;
};

// 概率算法
function randomProbability(chance: number): boolean {
  return Math.random() < chance / 100; // 0.1 表示 10% 的概率
}

const goToGS20page = (queryString?: string) => {
  const defaultL = getGS20DivertL();
  const cleanQuery = (queryString || '').replace(/^\?/, '');
  const searchParams = new URLSearchParams(cleanQuery);

  // 1. 优先获取传入 queryString 中的已有 l 或 L
  let existingL = searchParams.get('l') || searchParams.get('L');

  // 2. 如果入参没有携带，再从当前浏览器 URL 中获取原有的 l 或 L（兼容大小写）
  if (!existingL && typeof window !== 'undefined') {
    const currentUrlParams = new URLSearchParams(window.location.search);
    existingL = currentUrlParams.get('l') || currentUrlParams.get('L');
  }

  // 3. 只有在原链接和参数中完全没有 L 参数时，才使用分流默认的 L；原有 L 绝对不覆盖
  if (existingL) {
    searchParams.set('l', existingL);
  } else {
    searchParams.set('l', defaultL);
  }

  // 如果原本带有大写 L 参数，统一规范为小写 l，避免 URL 同时出现 l 与 L
  if (searchParams.has('L')) {
    searchParams.delete('L');
  }

  const finalQueryString = searchParams.toString();
  router.push(
    `/experienceClassBooking${finalQueryString ? `?${finalQueryString}` : ''}`,
  );
  return true;
};

const shouldCheckGS20 = (subject: string | undefined) => {
  return subject === 'chinese';
};

const shouldCheckLanguage = () => {
  return window?.location?.pathname?.startsWith('/zh');
};

const handleLoggedInUser = (student: StudentInfo, querystring?: string) => {
  if (student.gs20User) {
    return goToGS20page(querystring);
  }
  return false;
};
const getCachedVersion = () => {
  return Cookie.get('FOR_GS20_TYPE');
};

const handleCachedVersion = (cachedVersion: string, querystring?: string) => {
  if (cachedVersion === 'true') {
    return goToGS20page(querystring);
  }
  return false;
};

const splitTrafficAndCache = (querystring?: string) => {
  const isGS20 = randomProbability(40);
  Cookie.set('FOR_GS20_TYPE', isGS20 ? 'true' : 'false', { expires: 7 });

  if (isGS20) {
    return goToGS20page(querystring);
  }
  return false;
};

const handleGuestUser = (querystring?: string) => {
  const cachedVersion = getCachedVersion();

  if (cachedVersion) {
    return handleCachedVersion(cachedVersion, querystring);
  }

  return splitTrafficAndCache(querystring);
};

// 判断是否要跳转到GS2.0落地页
/**
 * AB Test 方案 @骆曦（Viva） @Kenny Yang（Kenny） @赵丹妮（Danielle）
 * AB 规则仅在英文语言环境下生效
 * 已登录用户， 判断学生 GS2.0 标签
 * 如果有 GS2.0 标签，则走 GS2.0 约课流程
 * 如果没有，则固定走GS1.0 约课流程
 * 未登录用户，判断当前是否已经有缓存分流版本
 * 如果有，则走缓存的分流版本
 * 如果没有，则根据分流比例，按概率进行分流，同时缓存当前的分流版本结果
 */

export const checkIfGoToGS20 = (
  subject: 'chinese' | 'math' | 'english' | undefined | '',
  student: StudentInfo | undefined,
  querystring?: string,
) => {
  if (shouldCheckLanguage()) {
    return false;
  }

  if (!shouldCheckGS20(subject)) {
    return false;
  }

  if (student) {
    return handleLoggedInUser(student as StudentInfo, querystring);
  }

  return handleGuestUser(querystring);
};

export const getErrorMsg = (err: any) => {
  if (typeof err === 'string') {
    return err;
  }
  if (err?.response && typeof err === 'object') {
    const { data = {} } = err.response;
    const { errors, message } = data;
    const errMsg =
      (errors && errors[Object.keys(errors)[0]]) || message || err.message;
    return errMsg;
  }
  return 'unknown error';
};
/**
 * 获取学员中心课表地址
 */
export const getStuScheduleUrl = (date?: string) => {
  const { origin, lang, fromParam } = getStuCenterHost();
  let url = `${origin}/${lang}/study/schedule`;
  if (date) {
    url += `${url.includes('?') ? '&' : '?'}externalDate=${date}`;
  }
  return `${url}${url.includes('?') ? '&' : '?'}from=${fromParam}`;
};

/**
 * App 跳转页面协议
 */
export const appJumpPage = (objStr: string) => {
  window?.webkit?.messageHandlers?.CallNative_JumpARouter?.postMessage?.(
    objStr,
  );
  window?.AppBridge?.CallNative_JumpARouter?.(objStr);
};

/**
 * 退出 App Webview
 */
export const exitWebView = () => {
  window?.webkit?.messageHandlers?.BACK?.postMessage?.('');
  window?.AppBridge?.BACK?.('');
};

/**
 * 版本号比较
 */
export const compareVersions = (
  currentVersion: string,
  specifiedVersion: string,
): boolean => {
  const currentParts = currentVersion.split('.').map(Number);
  const specifiedParts = specifiedVersion.split('.').map(Number);

  while (currentParts.length < specifiedParts.length) {
    currentParts.push(0);
  }
  while (specifiedParts.length < currentParts.length) {
    specifiedParts.push(0);
  }

  for (let i = 0; i < currentParts.length; i++) {
    if (currentParts[i] > specifiedParts[i]) {
      return true;
    }
    if (currentParts[i] < specifiedParts[i]) {
      return false;
    }
  }

  return true;
};

const APP_JUMP_SCHEDULE_VERSION = '1.14.0';

/**
 * 统一跳转课表方法（支持 Web 和 App）
 */
export const goSchedulePage = (params: {
  date?: string;
  isAppEnv?: boolean;
  appVersion?: string;
  isMobile?: boolean;
}) => {
  const { date, isAppEnv, appVersion = '0', isMobile = false } = params;

  // app
  if (isAppEnv) {
    if (compareVersions(appVersion, APP_JUMP_SCHEDULE_VERSION)) {
      appJumpPage(
        JSON.stringify({
          path: 'class',
          type: 'INTERNAL',
          customData: { date: date || dayjs().format('YYYY-MM-DD') },
        }),
      );
    } else {
      exitWebView();
    }
    return;
  }

  // web
  if (isMobile) {
    goStudentCenterHome();
    return;
  }
  const url = getStuScheduleUrl(date);
  window.location.href = url;
};
